export const LOADING = (data) => {
  return {
    type: "LOADING",
    payload: data,
  };
};

export const LINEAR_LOADING = (data) => {
  return {
    type: "LINEAR_LOADING",
    payload: data,
  };
};

export const SET_THEME = () => {
  return {
    type: "SET_THEME",
  };
};
